import React from 'react';
import ContentLoader from 'react-content-loader';
import { useResizeObserver } from 'usehooks-ts';

import styles from './vehicleCardLoader.module.scss';

const VehicleCardLoader: React.FC = (props) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { width: containerWidth = 600 } = useResizeObserver({ ref });
  return (
    <div ref={ref} className={styles['vehicle-card-loader']}>
      <ContentLoader
        speed={2}
        width={containerWidth}
        height={172}
        viewBox={`0 0 ${containerWidth} 172`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        {/* Thumbnail */}
        <rect x="16" y="16" rx="0" ry="0" width="140" height="140" />

        <rect x="172" y="16" rx="0" ry="0" width="200" height="32" />
        <rect x="172" y="68" rx="0" ry="0" width={containerWidth - (2 * 172)} height="13" />
        <rect x="172" y="87" rx="0" ry="0" width={containerWidth - (3 * 172)} height="13" />
        <rect x="172" y="120" rx="0" ry="0" width={containerWidth - (3.4 * 172)} height="13" />
        <rect x="172" y="143" rx="0" ry="0" width={containerWidth - (3.4 * 172)} height="13" />
        <rect x={containerWidth - 16 - 76} y="16" rx="0" ry="0" width="76" height="32" />
      </ContentLoader>
    </div>
  );
};

export default VehicleCardLoader;
